import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--visibility"
export default class extends Controller {
  static targets = ["container"]

  async toggleContainer(event) {
    event.preventDefault()
    this.containerTarget.hidden = !this.containerTarget.hidden

  }

}
